import { render, staticRenderFns } from "./AddAllotment.vue?vue&type=template&id=4d3b337c&"
import script from "./AddAllotment.vue?vue&type=script&lang=js&"
export * from "./AddAllotment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports